/**
 * Created by Shen Mo on 2021/8/4
 */

import { handleAction } from './index';

const _SUCCEED = `_SUCCEED`,
	_FAILED = `_FAILED`,
	_FIN = `_FIN`;
export const actionCreator = (category) => {
	const _CTG_TAG = `${category.toUpperCase()}`;
	// 创建 action 的方法
	const createActionName = (name) => `${_CTG_TAG}/${name}`;

	// 创建ACTION的快捷方法
	const createAction = (data) => handleAction(data, category);
	const createBasicAction = (type) => {
		/**
		 * an action builder function
		 * @param {object=} [data] - action data can be undefined
		 */
		return (data = null) => {
			if (data) {
				return createAction({ type, ...data });
			}

			return createAction({ type });
		};
	};

	function _createAction(actionName) {
		let _actionName = createActionName(actionName);
		let _action = createBasicAction(_actionName);

		return [_actionName, _action];
	}
	_createAction.async = (actionName, isOnlyFin = false) => {
		if (isOnlyFin) {
			return {
				fin: [actionName + _FIN, createBasicAction(actionName + _FIN)],
			};
		}
		return {
			succeed: [actionName + _SUCCEED, createBasicAction(actionName + _SUCCEED)],
			failed: [actionName + _FAILED, createBasicAction(actionName + _FAILED)],
		};
	};

	return _createAction;
};
